<script lang="ts">
    import NewColumnSelectListItem from './NewColumnSelectListItem.svelte';
    import Select from 'svelte-select';

    export let selectedId: string = '';
    export let items: any[] = [];
    export let itemId: string = 'id';
    export let onChange: (id: string) => void;

    let item = items.find(i => i.id === selectedId);

    let previuosSelectedId = selectedId;

    $: {
        // console.log('NewColumnSelectContainer: selectedId:', selectedId, 'item:', item);
        if (selectedId !== previuosSelectedId) {
            item = items.find(i => i.id === selectedId) ?? null;
            previuosSelectedId = selectedId;
            console.log('NewColumnSelectContainer: item:', item);
        }
    }
</script>

<div style="width: 240px;">
    <Select
        class=""
        showChevron={true}
        clearable={false}
        searchable={false}
        {items}
        {itemId}
        placeholder=""
        value={item}
        id={selectedId}
        on:change={e => {
            console.log('selected: ', e.detail);
            selectedId = e.detail.id;
            onChange(e.detail.id);
        }}
        on:clear={() => {
            console.log('clear: ');
            onChange('');
        }}
    >
        <div class="bb" slot="item" let:item let:index>
            <NewColumnSelectListItem {item} />
        </div>
        <div class="bb" slot="selection" let:selection>
            <div class="selected-item">{selection.label}</div>
        </div>
    </Select>
</div>

<style>
    :root {
        --font-size: 15px;
        --chevron-width: 20px;
        --chevron-height: 20px;
    }
    :global(.svelte-select) {
        border-radius: 0 !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #bababa !important;
        min-height: 30px !important;
        padding: 0 0 0 5px !important;
    }
    .selected-item {
        font-weight: 500;
    }
    :global(.list-item .item) {
        padding: 0 !important;
    }
</style>
